// utils/areaDataConverter.js

/**
 * 将后端树形数据转换为级联选择器需要的格式
 * @param {Array} originalData 后端返回的原始数据
 * @param {Number} showLevel 最大展示层级
 * @param {Object} options 配置选项
 * @returns {Array} 转换后的数据
 */
export function convertToCascaderFormat(originalData, showLevel = 2, options = {}) {
  const {
    // value 字段来源
    // valueField = 'id',
    // label 字段来源
    labelField = 'areaName',
    childrenField = 'children' // children 字段名
  } = options

  if (!originalData || !Array.isArray(originalData)) {
    return []
  }

  return originalData.map(item => {
    const node = {
      value: item[labelField], // 确保是字符串
      label: item[labelField],
      // 保留原始数据，方便后续使用
      rawData: { ...item },
      // 根据需要保留其他字段
      id: item.id,
      level: item.level,
      fullName: item.fullName,
      centerLatLon: item.centerLatLon
    }

    // 递归处理子节点(目前只查询省市即可，区没有筛选意义)
    if (item.level < showLevel && item[childrenField] && item[childrenField].length > 0) {
      node.children = convertToCascaderFormat(item[childrenField], showLevel, options)
    } else {
      node.children = []
    }

    return node
  })
}

/**
 * 懒加载转换函数（用于异步加载子节点）
 * @param {Array} children 子节点数据
 * @param {Object} options 配置
 * @returns {Array}
 */
export function convertChildren(children, options = {}) {
  const {
    // valueField = 'id',
    labelField = 'areaName'
  } = options

  return children.map(child => ({
    value: child[labelField],
    label: child[labelField],
    rawData: child,
    // 判断是否还有下级（通常 level < 3 表示还有下级）
    isLeaf: child.level >= 3,
    children: child.children ? convertChildren(child.children, options) : []
  }))
}
